export default "/images/star-outlined.svg?4810edb4aef5edb0a0960c2fa9ec0f7e";